const general = {
  welcomeMessage: 'Hella narwhal Cosby sweater McSweeneys, salvia kitsch before they sold out.',
  lightMode: 'Light mode',
  darkMode: 'Dark mode',
  error: 'Something went wrong! Please try again later!',
  filters: 'Filters',
  reset: 'Reset',
  resetPassword: 'Reset password',
  resetPasswordMessage: 'Please use your work email to reset your password.',
  setNewPassword: 'Set new password',
  javascriptMasterEchovoxUA: 'Javascript Master @ EchovoxUA',
  checkYourEmailToResetThePassword: 'Check your email to reset the password',
  noResults: 'No results',
  first: 'First',
  last: 'Last',
  next: 'Next',
  addRegion: 'Add region',
  saveRegion: 'Save region',
  deleteRegion: 'Delete region',
  regions: 'Regions',
  passwordUpdated: 'Password Updated!',
  itemURLHasBeenCopied: 'Item URL has been copied!',
  itemHasBeenCopied: 'Item has been copied!',
  productIDHasBeenCopied: 'Product ID has been copied!',
  welcomeBack: 'Welcome back',
  sessionEnded: 'Session ended!',
  recoverSession: 'Trying to recover session',
  sessionHasBeenRecovered: 'Session has been successfully recovered!',
  identity: 'Identity',
  order: 'Order',
  notificationDefinition: 'Notification definition',
  product: 'Product',
  store: 'Store',
  recommendation: 'Recommendation',
  discount: 'Discount',
  catalog: 'Catalog',
  price: 'Price',
  emailTemplate: 'Email template',
  priceFunction: 'Price Function',
  hasBeenSuccessfullyDeleted: ' has been successfully deleted!',
  updatesHaveBeenSaved: 'Updates have been saved!',
  partialRefundIssued: 'Partial refund has been issued!',
  fullRefundPeriodAllowed: 'Full refund period allowed - It is advisable to choose full refund',
  sendByEmailByCartIdSuccessed: 'Cart sent by email',
  sendByEmailByCartIdFailure: "Can't send cart by email",
  resendEmail: 'Re-send email',
  retrySendingNotificationSuccessed: 'A retry on notification has been forced',
  retrySendingNotificationFailure: "A retry on notification hasn't been forced",
  selectImage: ' Select image',
  generateCodes: 'Generate codes',
  features: ' Features',
  live: 'Live',
  test: ' Test',
  payment: 'Payment',
  translation: 'Translation',
  theme: 'Theme',
  font: 'Font',
  layout: 'Layout',
  markup: 'Markup',
  checkout: 'Checkout',
  checkoutWithTrial: 'Checkout with trial',
  save: 'Save',
  add: 'Add',
  noPackagesFound: 'No packages found',
  addProduct: 'Add Product',
  addPrice: 'Add Price',
  addRecommendation: 'Add Recommendation',
  addCampaign: 'Add Campaign',
  addTnc: 'Add T&C',
  noAvailableOptions: 'No available options',
  marketingNameMandatory: 'Marketing name is mandatory for the default language.',
  noCustomer: 'No customer selected',
  selectCustomer: 'Please select a customer which will own the created resource.',
  campaign: 'Campaign',
  new: 'New',
  selectNoSourceMeans: 'Select no source means the same as "all sources are selected"',
  role: 'role',
  customer: 'Customer',
  profile: 'Profile',
  logoCenter: 'Center.',
  subscription: 'Subscription',
  privileges: {
    general: 'General',
    createdate: 'Create date',
    lastupdate: 'Last update',
    lastupdatereason: 'Last update reason',
    servicename: 'Service name',
    availableactions: 'Available actions',
    description: 'Description',
  },
  onboard: 'Onboarding on Monetize',
  onboardDescriptionText:
    'Welcome to the Nexway onboarding website. The process of onboarding is split into several consecutive steps. Please ensure to have the onboarding guide (PDF) at hand, before you start.',
  keyHasBeenAdded: 'Key Has Been Added',
  keyHasBeenRemoved: 'Key Has BeenRemoved',
  secretsHaveBeenRemoved: 'Secrets Have Been Removed',
  noResourcesMatchCriteria: 'No resources match criteria',
  typeOfIdentity:
    'The type of identity is choosen at creation and cannot be modified afterwards. Choose "User" to declare a human agent, and "Application"to obtain credentials for your bots accessing Monetize services.',
  maxNumberOfSecretKeys: 'The maximum number of secret keys is 5',
  listOfIdentityCustomers:
    'This is the list of customers this identity is allowed to manage, in addition to the customer owning this identity.',
  selectFiles: 'Select files from your computer or click to enter custom URL',
  uploadFiles: ' upload files',
  addAssets: 'Add Assets',
  privilege: 'privilege',
  notificationEnabled: 'Enabled',
  notificationDisabled: 'Disabled',
  notification: 'Notification',
  rowsPerPage: 'Rows per page',
  notifications: {
    notification: 'notification',
    notificationDefinition: 'notification definition',
  },
  cart: 'Cart',
  addCart: 'Add Cart',
  endUsersGroups: 'End-users Groups',
  addEndUsersGroups: 'Add End-users Groups',
  onboarding: 'Onboarding',
  fulfillmentPackages: 'Fulfillment packages',
  findColumn: 'Find column',
  hideAll: 'Hide All',
  showAll: 'Show All',
  licenseProviderDefinition: 'License Provider Definition',
  disableStore: 'Are you sure you want to disable the store?',
  force: 'Force',
  noOrdersYet: 'No orders yet',
  noSubscriptionsYet: 'No subscriptions yet',
  noEmails: 'No emails',
  clearFilters: 'Clear filters',
  saveView: 'Save View',
  addFilterView: 'Add Filter View',
  editFilterView: 'Edit Filter View',
  exportFiles: 'Export files',
  'exportFiles-product': 'Product Export Files',
  'exportFiles-subscription': 'Subscription Export Files',
  'exportFiles-discount': 'Discount Rules Export Files',
  applyChangesTo: 'Apply changes to',
  abandoned: 'Abandoned',
  licenseExpiration: 'License Expiration',
  licenses: 'Licenses',
  and: 'and',
  noTmplData: 'No template data',
  subjectIsMandatory: 'Subject is mandatory.',
  templateCloned: 'Email template successfully cloned',
  productsWith: ' Products with',
  upload: 'Upload',
  download: 'Download',
  copy: 'Copy',
  reload: 'Reload',
  noResourceUrl: 'No resource URL selected',
  selectResource: 'Please select an endpoint and press the reload button.',
  onTheFollowingEmailAddress: 'on the following email address: ',
  noSubscriptions: 'No subscriptions',
  manualFulfillment: 'Manual fulfillment',
  pleaseEitherDropAKeyfileHere: 'Please either drop a keyfile here',
  validKeyfile:
    'Valid keyfile contains a line by license key, with just license key on the line, followed by end-of-line character',
  abandonedCart: 'Abandoned Cart',
  pleaseSelectFallbackLocale: 'Please select a fallback locale',
  realm: 'Realm',
  input: 'input',
  addLanguage: 'Add Language',
  needsToBeSelected: 'needs to be selected',
  forAdding: 'For adding',
  duplicateNextSections: 'Duplicate next sections',
  crud: 'C.R.U.D.',
  post: 'Post',
  put: 'Put',
  hasGivenConsent: 'Has given consent',
  errors: 'errors',
  remove: 'Remove',
  step: 'Step',
  customFieldDefinitions: 'Custom Field',
  promptUnsavedData: 'There is unsaved data. Are you sure you want to leave?',
  timezoneDescription: 'Select the timezone in which all datetimes will be expressed in MyNexway.',
  noPaymentMethods: 'Now payment methods',
  ordersExportFirstButton: 'EXPORT RESULTS',
  ordersExportSecondButton: 'CLEAR FILTER',
  invoicesExportFirstButton: 'EXPORT INVOICE',
  invoicesExportSecondButton: 'CLEAR FILTERS',
  filterPerOrderID: 'Filter per order ID',
  dropzoneCSVdescription: 'Drop a file here to upload or choose a file (Authorized files : CSV format)',
  displayResult: 'Display Results',
  clearFilters: 'Clear Filters',
  ordersExportDisplayResults: 'DISPLAY RESULTS',
  reviewRefundDetails: 'Please review the refund details before confirming.',
  itemsForRefund: 'Selecting items for refund:',
  typeReimbursement: 'Select the type of reimbursement for each product',
};

export default general;
